import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Image from '../../components/AppImage';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import BottomTabNavigation from '../../components/ui/BottomTabNavigation';
import PricePackageCard from './components/PricePackageCard';
import ReviewCard from './components/ReviewCard';
import InfoSection from './components/InfoSection';
import GallerySection from './components/GallerySection';

const VendorDetailModal = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isVisible, setIsVisible] = useState(false);

    const vendorData = {
        id: 1,
        name: "Elegant Moments Photography",
        category: "Wedding Photography",
        rating: 4.8,
        reviewsCount: 127,
        image: "https://images.unsplash.com/photo-1653301597353-abc3f2a0214d",
        imageAlt: "Professional wedding photographer capturing bride and groom during golden hour ceremony with elegant floral decorations in background",
        location: "Downtown Arts District, Los Angeles",
        city: "Los Angeles",
        state: "California",
        phone: "+1-555-0123",
        email: "contact@elegantmoments.com",
        description: "Elegant Moments Photography specializes in capturing the most precious moments of your special day with artistic vision and professional expertise. With over 10 years of experience in wedding photography, we blend traditional and contemporary styles to create timeless memories. Our team uses state-of-the-art equipment and post-production techniques to deliver stunning, high-quality images that tell your unique love story.",
        experience: "10+ years",
        completedEvents: 250,
        teamSize: 5,
        packages: [
            {
                name: "Silver Package",
                duration: "6 hours coverage",
                price: 1500,
                features: [
                    { text: "Single photographer", included: true },
                    { text: "300+ edited photos", included: true },
                    { text: "Online gallery access", included: true },
                    { text: "Pre-wedding consultation", included: true },
                    { text: "Second photographer", included: false },
                    { text: "Engagement shoot", included: false },
                    { text: "Photo album", included: false }],

                note: "Perfect for intimate ceremonies and smaller gatherings"
            },
            {
                name: "Gold Package",
                duration: "Full day coverage",
                price: 2800,
                features: [
                    { text: "Two professional photographers", included: true },
                    { text: "600+ edited photos", included: true },
                    { text: "Online gallery with download", included: true },
                    { text: "Pre-wedding consultation", included: true },
                    { text: "Complimentary engagement shoot", included: true },
                    { text: "Premium photo album (50 pages)", included: true },
                    { text: "Same-day highlight reel", included: true }],

                note: "Most popular choice for full wedding coverage with premium deliverables"
            }],

        gallery: [
            {
                url: "https://images.unsplash.com/photo-1571984128445-91f01fd094ae",
                alt: "Bride in white lace wedding dress holding colorful bouquet of roses and peonies with soft natural lighting"
            },
            {
                url: "https://img.rocket.new/generatedImages/rocket_gen_img_13696f82f-1769202119777.png",
                alt: "Groom in navy blue suit adjusting cufflinks with groomsmen in matching attire standing in elegant venue"
            },
            {
                url: "https://images.unsplash.com/photo-1566231900271-8b6bcb8baea8",
                alt: "Wedding ceremony setup with white chairs arranged in rows and floral arch decorated with roses"
            },
            {
                url: "https://images.unsplash.com/photo-1685459494112-0a3199407594",
                alt: "Romantic couple portrait during sunset with golden hour lighting and scenic outdoor background"
            },
            {
                url: "https://images.unsplash.com/photo-1592787610600-1d2e0c03e951",
                alt: "Wedding reception table decorated with elegant centerpieces candles and fine dining setup"
            }],

        services: [
            "Wedding Photography",
            "Engagement Shoots",
            "Pre-wedding Sessions",
            "Candid Photography",
            "Traditional Portraits",
            "Drone Photography",
            "Photo Editing",
            "Album Design"],

        reviews: [
            {
                name: "Sarah Johnson",
                avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_18e031c2b-1763294898016.png",
                avatarAlt: "Professional headshot of blonde woman with warm smile wearing elegant pearl necklace",
                rating: 5.0,
                date: "January 15, 2026",
                comment: "Absolutely phenomenal experience! The team captured every special moment of our wedding day with such artistry and professionalism. The photos exceeded our expectations and we couldn\'t be happier with the results. Highly recommend!",
                helpful: 24,
                images: [
                    {
                        url: "https://images.unsplash.com/photo-1707192324808-badf097b0f32",
                        alt: "Wedding couple dancing under string lights during evening reception"
                    },
                    {
                        url: "https://images.unsplash.com/photo-1705362431127-1c42980e6742",
                        alt: "Close-up of bride\'s hands holding wedding bouquet with diamond ring visible"
                    }]

            },
            {
                name: "Michael Chen",
                avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1d16af3b8-1763294225599.png",
                avatarAlt: "Professional headshot of Asian man with black hair wearing dark suit and tie",
                rating: 4.8,
                date: "December 28, 2025",
                comment: "Great photography service with attention to detail. They made us feel comfortable throughout the day and captured beautiful candid moments. The turnaround time for edited photos was impressive. Would definitely recommend to friends!",
                helpful: 18
            },
            {
                name: "Emily Rodriguez",
                avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1de57631c-1763294258585.png",
                avatarAlt: "Professional headshot of Hispanic woman with long brown hair wearing white blouse",
                rating: 5.0,
                date: "November 10, 2025",
                comment: "The engagement shoot was amazing and really helped us feel comfortable before the big day. The wedding photos are absolutely stunning - they captured the emotion and joy perfectly. The online gallery made sharing with family so easy!",
                helpful: 31,
                images: [
                    {
                        url: "https://images.unsplash.com/photo-1485993324199-67c772723e24",
                        alt: "Couple embracing during engagement photoshoot in urban setting with brick wall background"
                    }]

            },
            {
                name: "David Thompson",
                avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_14588f7f1-1763295690005.png",
                avatarAlt: "Professional headshot of man with short brown hair wearing casual button-down shirt",
                rating: 4.5,
                date: "October 5, 2025",
                comment: "Very professional team with great equipment. They were punctual and worked efficiently throughout the event. The photos came out beautifully and captured all the important moments. Minor delay in delivery but overall excellent service.",
                helpful: 12
            }],

        availability: {
            nextAvailable: "February 20, 2026",
            bookedDates: ["February 14, 2026", "March 8, 2026", "March 22, 2026"]
        }
    };

    useEffect(() => {
        setIsVisible(true);
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, []);

    const handleBack = () => {
        setIsVisible(false);
        setTimeout(() => {
            navigate(-1);
        }, 250);
    };

    const handleWhatsAppClick = () => {
        const message = encodeURIComponent(
            `Hi! I'm interested in your ${vendorData?.category} services for my upcoming event. I found your profile on ServiceHub and would like to discuss availability and pricing. Looking forward to hearing from you!`
        );
        const whatsappUrl = `https://wa.me/${vendorData?.phone?.replace(/[^0-9]/g, '')}?text=${message}`;
        window.open(whatsappUrl, '_blank');
    };

    const handleCallClick = () => {
        window.location.href = `tel:${vendorData?.phone}`;
    };

    const handleEmailClick = () => {
        const subject = encodeURIComponent(`Inquiry about ${vendorData?.category} services`);
        const body = encodeURIComponent(
            `Hello ${vendorData?.name},\n\nI'm interested in your services for my upcoming event. Please provide more details about availability and packages.\n\nThank you!`
        );
        window.location.href = `mailto:${vendorData?.email}?subject=${subject}&body=${body}`;
    };

    return (
        <div className="min-h-screen bg-background">
            <div
                className={`fixed inset-0 bg-background z-50 transition-opacity duration-300 ${isVisible ? 'opacity-100' : 'opacity-0'}`
                }>

                <div className="h-full overflow-y-auto pb-32 md:pb-24">
                    {/* Header with Back Button */}
                    <div className="sticky top-0 z-10 bg-background/95 backdrop-blur-sm border-b border-border">
                        <div className="max-w-screen-xl mx-auto px-4 md:px-6 py-3 md:py-4">
                            <div className="flex items-center gap-3">
                                <button
                                    onClick={handleBack}
                                    className="w-10 h-10 flex items-center justify-center rounded-lg bg-card hover:bg-muted transition-colors"
                                    aria-label="Go back">

                                    <Icon name="ArrowLeft" size={20} />
                                </button>
                                <div className="flex-1 min-w-0">
                                    <h1 className="text-lg md:text-xl font-heading font-semibold text-foreground truncate">
                                        Vendor Details
                                    </h1>
                                </div>
                                <button
                                    onClick={handleEmailClick}
                                    className="w-10 h-10 flex items-center justify-center rounded-lg bg-card hover:bg-muted transition-colors"
                                    aria-label="Send email">

                                    <Icon name="Mail" size={20} />
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Hero Image */}
                    <div className="relative aspect-[16/9] md:aspect-[21/9] bg-muted">
                        <Image
                            src={vendorData?.image}
                            alt={vendorData?.imageAlt}
                            className="w-full h-full object-cover" />

                        <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent" />
                        <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                            <div className="max-w-screen-xl mx-auto">
                                <div className="flex items-end justify-between gap-4">
                                    <div className="flex-1 min-w-0">
                                        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-2">
                                            {vendorData?.name}
                                        </h2>
                                        <p className="text-sm md:text-base text-white/90">{vendorData?.category}</p>
                                    </div>
                                    <div className="flex items-center gap-2 px-3 md:px-4 py-2 rounded-xl bg-warning/90 backdrop-blur-sm flex-shrink-0">
                                        <Icon name="Star" size={18} className="text-white" />
                                        <span className="text-base md:text-lg font-data font-bold text-white">
                                            {vendorData?.rating?.toFixed(1)}
                                        </span>
                                        <span className="text-xs md:text-sm text-white/90">
                                            ({vendorData?.reviewsCount})
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className="max-w-screen-xl mx-auto px-4 md:px-6 py-6 md:py-8 space-y-6 md:space-y-8">
                        {/* Quick Stats */}
                        <div className="grid grid-cols-3 gap-3 md:gap-4">
                            <div className="p-4 md:p-5 rounded-xl bg-card border border-border text-center">
                                <div className="w-10 h-10 md:w-12 md:h-12 mx-auto mb-2 flex items-center justify-center rounded-lg bg-primary/10">
                                    <Icon name="Award" size={20} className="text-primary" />
                                </div>
                                <div className="text-xl md:text-2xl font-data font-bold text-foreground mb-1">
                                    {vendorData?.experience}
                                </div>
                                <div className="text-xs md:text-sm text-muted-foreground">Experience</div>
                            </div>
                            <div className="p-4 md:p-5 rounded-xl bg-card border border-border text-center">
                                <div className="w-10 h-10 md:w-12 md:h-12 mx-auto mb-2 flex items-center justify-center rounded-lg bg-success/10">
                                    <Icon name="CheckCircle2" size={20} className="text-success" />
                                </div>
                                <div className="text-xl md:text-2xl font-data font-bold text-foreground mb-1">
                                    {vendorData?.completedEvents}+
                                </div>
                                <div className="text-xs md:text-sm text-muted-foreground">Events</div>
                            </div>
                            <div className="p-4 md:p-5 rounded-xl bg-card border border-border text-center">
                                <div className="w-10 h-10 md:w-12 md:h-12 mx-auto mb-2 flex items-center justify-center rounded-lg bg-secondary/10">
                                    <Icon name="Users" size={20} className="text-secondary" />
                                </div>
                                <div className="text-xl md:text-2xl font-data font-bold text-foreground mb-1">
                                    {vendorData?.teamSize}
                                </div>
                                <div className="text-xs md:text-sm text-muted-foreground">Team Size</div>
                            </div>
                        </div>

                        {/* About Section */}
                        <InfoSection icon="Info" title="About">
                            <p className="text-sm md:text-base text-card-foreground leading-relaxed">
                                {vendorData?.description}
                            </p>
                        </InfoSection>

                        {/* Location Section */}
                        <InfoSection icon="MapPin" title="Location">
                            <div className="p-4 md:p-5 rounded-xl bg-card border border-border">
                                <div className="flex items-start gap-3 mb-3">
                                    <Icon name="MapPin" size={20} className="text-primary mt-0.5 flex-shrink-0" />
                                    <div>
                                        <p className="text-sm md:text-base font-medium text-foreground mb-1">
                                            {vendorData?.location}
                                        </p>
                                        <p className="text-xs md:text-sm text-muted-foreground">
                                            {vendorData?.city}, {vendorData?.state}
                                        </p>
                                    </div>
                                </div>
                                <div className="aspect-video rounded-lg overflow-hidden bg-muted">
                                    <iframe
                                        width="100%"
                                        height="100%"
                                        loading="lazy"
                                        title={vendorData?.name}
                                        referrerPolicy="no-referrer-when-downgrade"
                                        src="https://www.google.com/maps?q=34.0522,-118.2437&z=14&output=embed" />

                                </div>
                            </div>
                        </InfoSection>

                        {/* Services Section */}
                        <InfoSection icon="Briefcase" title="Services Offered">
                            <div className="flex flex-wrap gap-2">
                                {vendorData?.services?.map((service, index) =>
                                    <span
                                        key={index}
                                        className="px-3 py-1.5 md:px-4 md:py-2 rounded-lg bg-muted text-xs md:text-sm font-medium text-foreground">

                                        {service}
                                    </span>
                                )}
                            </div>
                        </InfoSection>

                        {/* Gallery Section */}
                        <InfoSection icon="Image" title="Portfolio Gallery">
                            <GallerySection images={vendorData?.gallery} />
                        </InfoSection>

                        {/* Pricing Packages */}
                        <InfoSection icon="DollarSign" title="Pricing Packages">
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
                                {vendorData?.packages?.map((pkg, index) =>
                                    <PricePackageCard
                                        key={index}
                                        packageData={pkg}
                                        isPopular={index === 1} />

                                )}
                            </div>
                        </InfoSection>

                        {/* Contact Information */}
                        <InfoSection icon="Phone" title="Contact Information">
                            <div className="space-y-3">
                                <button
                                    onClick={handleCallClick}
                                    className="w-full flex items-center gap-3 p-4 md:p-5 rounded-xl bg-card border border-border hover:bg-muted transition-colors">

                                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary/10 flex-shrink-0">
                                        <Icon name="Phone" size={20} className="text-primary" />
                                    </div>
                                    <span className="text-sm md:text-base font-data text-foreground">
                                        {vendorData?.phone}
                                    </span>
                                </button>
                                <button
                                    onClick={handleEmailClick}
                                    className="w-full flex items-center gap-3 p-4 md:p-5 rounded-xl bg-card border border-border hover:bg-muted transition-colors">

                                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary/10 flex-shrink-0">
                                        <Icon name="Mail" size={20} className="text-secondary" />
                                    </div>
                                    <span className="text-sm md:text-base text-foreground break-all">
                                        {vendorData?.email}
                                    </span>
                                </button>
                            </div>
                        </InfoSection>

                        {/* Reviews Section */}
                        <InfoSection icon="MessageSquare" title={`Reviews (${vendorData?.reviewsCount})`}>
                            <div className="space-y-4">
                                {vendorData?.reviews?.map((review, index) =>
                                    <ReviewCard key={index} review={review} />
                                )}
                            </div>
                        </InfoSection>

                        {/* Availability Notice */}
                        <div className="p-4 md:p-5 rounded-xl bg-accent/10 border border-accent/20">
                            <div className="flex items-start gap-3">
                                <Icon name="Calendar" size={20} className="text-accent mt-0.5 flex-shrink-0" />
                                <div>
                                    <h4 className="text-sm md:text-base font-medium text-foreground mb-1">
                                        Next Available Date
                                    </h4>
                                    <p className="text-xs md:text-sm text-muted-foreground">
                                        {vendorData?.availability?.nextAvailable} - Book now to secure your date!
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Sticky Bottom Action Bar */}
                <div className="fixed bottom-0 left-0 right-0 bg-card border-t border-border z-20 pb-16 md:pb-0">
                    <div className="max-w-screen-xl mx-auto px-4 md:px-6 py-3 md:py-4">
                        <div className="flex gap-3">
                            <Button
                                variant="outline"
                                iconName="Phone"
                                iconPosition="left"
                                onClick={handleCallClick}
                                className="flex-1">

                                Call Now
                            </Button>
                            <Button
                                variant="default"
                                iconName="MessageCircle"
                                iconPosition="left"
                                onClick={handleWhatsAppClick}
                                className="flex-1">

                                Check Availability on WhatsApp
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <BottomTabNavigation />
        </div>);

};

export default VendorDetailModal;